import Constants from "../Constants";
import { ActionInterface } from "../../Interface/ActionInterface";

class ConfirmActions {

  public forgotPasswordRequest(user): ActionInterface {
    return {
      type: Constants.PAGE_CONFIRM_FORGOT_PASSWORD_REQUEST,
      payload: {
        user
      }
    };
  }

  public forgotPasswordSuccess(res): ActionInterface {
    return {
      type: Constants.PAGE_CONFIRM_FORGOT_PASSWORD_SUCCESS,
      payload: {
        res
      }
    };
  }

  public forgotPasswordFailure(err): ActionInterface {
    return {
      type: Constants.PAGE_CONFIRM_FORGOT_PASSWORD_FAILURE,
      payload: {
        err
      }
    };
  }

  public resendConfirmationMailRequest(data): ActionInterface {
    return {
      type: Constants.PAGE_CONFIRM_RESEND_CONFIRMATION_EMAIL_REQUEST,
      payload: {
        data
      }
    };
  }

  public resendConfirmationMailSuccess(res): ActionInterface {
    return {
      type: Constants.PAGE_CONFIRM_RESEND_CONFIRMATION_EMAIL_SUCCESS,
      payload: {
        res
      }
    };
  }

  public resendConfirmationMailFailure(err): ActionInterface {
    return {
      type: Constants.PAGE_CONFIRM_RESEND_CONFIRMATION_EMAIL_FAILURE,
      payload: {
        err
      }
    };
  }

  public resendInviteMailRequest(data): ActionInterface {
    return {
      type: Constants.PAGE_CONFIRM_RESEND_INVITE_EMAIL_REQUEST,
      payload: {
        data
      }
    };
  }

  public resendInviteMailSuccess(res): ActionInterface {
    return {
      type: Constants.PAGE_CONFIRM_RESEND_INVITE_EMAIL_SUCCESS,
      payload: {
        res
      }
    };
  }

  public resendInviteMailFailure(err): ActionInterface {
    return {
      type: Constants.PAGE_CONFIRM_RESEND_INVITE_EMAIL_FAILURE,
      payload: {
        err
      }
    };
  }

  public confirmAccountRequest(password, confirmPassword, token, type): ActionInterface {
    return {
      type: Constants.PAGE_CONFIRM_CONFIRM_ACCOUNT_REQUEST,
      payload: {
        password,
        confirmPassword,
        token,
        type,
        hideSnackbar: true
      }
    };
  }

  public confirmAccountSuccess(user): ActionInterface {
    return {
      type: Constants.PAGE_CONFIRM_CONFIRM_ACCOUNT_SUCCESS,
      payload: {
        user
      }
    };
  }

  public confirmAccountFailure(err): ActionInterface {
    return {
      type: Constants.PAGE_CONFIRM_CONFIRM_ACCOUNT_FAILURE,
      payload: {
        err
      }
    };
  }

  public resetPasswordRequest(password, confirmPassword, token): ActionInterface {
    return {
      type: Constants.PAGE_CONFIRM_RESET_PASSWORD_REQUEST,
      payload: {
        password,
        confirmPassword,
        token
      }
    };
  }

  public resetPasswordSuccess(user): ActionInterface {
    return {
      type: Constants.PAGE_CONFIRM_RESET_PASSWORD_SUCCESS,
      payload: {
        user
      }
    };
  }

  public resetPasswordFailure(err): ActionInterface {
    return {
      type: Constants.PAGE_CONFIRM_RESET_PASSWORD_FAILURE,
      payload: {
        err
      }
    };
  }

  public signinRequest(id, password, agencyId, email): ActionInterface {
    return {
      type: Constants.PAGE_CONFIRM_SIGNIN,
      payload: {
        id: id,
        password: password,
        agencyId: agencyId,
        email: email
      }
    };
  }

  public signinSuccess(user): ActionInterface {
    return {
      type: Constants.PAGE_CONFIRM_SIGNIN_SUCCESS,
      payload: {
        user
      }
    };
  }

  public signinFailure(err): ActionInterface {
    return {
      type: Constants.PAGE_CONFIRM_SIGNIN_FAILURE,
      payload: {
        err
      }
    };
  }

  public updatePassword(password): ActionInterface {
    return {
      type: Constants.PAGE_CONFIRM_UPDATE_PASSWORD,
      payload: {
        password
      }
    };
  }

  public updateConfirmPassword(confirmPassword): ActionInterface {
    return {
      type: Constants.PAGE_CONFIRM_UPDATE_CONFIRM_PASSWORD,
      payload: {
        confirmPassword
      }
    };
  }

  public openPopup(message, fields = [], translatedMessage = ""): ActionInterface {
    return {
      type: Constants.PAGE_CONFIRM_OPEN_POPUP,
      payload: {
        message,
        fields,
        translatedMessage
      }
    };
  }

  public closePopupStart(): ActionInterface {
    return {
      type: Constants.PAGE_CONFIRM_CLOSE_POPUP_START
    };
  }

  public closePopup(): ActionInterface {
    return {
      type: Constants.PAGE_CONFIRM_CLOSE_POPUP
    };
  }
}

export default new ConfirmActions();
